import { Container, Row, Col, Badge, Button, Card } from 'react-bootstrap';
import { motion } from 'motion/react';
import creativeData from '../../data/creativeData.json';

const Herosection = () => {
  const { hero } = creativeData

  const getImage = (imageName) => {
    return require(`../../assets/${imageName}`)
  }

  const contentVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  const imageVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  const renderStars = (rating) => {
    const stars = []
    const fullStars = Math.floor(rating)
    const hasHalfStar = rating % 1 !== 0

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={`full-${i}`} className="ri-star-fill text-warning"></i>)
    }
    if (hasHalfStar) {
      stars.push(<i key="half" className="ri-star-half-fill text-warning"></i>)
    }
    return stars
  }

  return (
    <section className="hero-section-primary min-vh-100 position-relative overflow-hidden d-flex align-items-center">
      <Container className="position-relative z-2">
        <Row className="align-items-center gy-5">
          <Col lg={6}>
            <motion.div className="hero-content" variants={contentVariants} initial="hidden" animate="visible">
              <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.2 }}>
                <Badge bg="success" className="px-3 py-2 mb-3">
                  <i className={`${hero.badge.icon} me-2`}></i>{hero.badge.text}
                </Badge>
              </motion.div>
              <motion.h2  className="display-4 fw-bold text-gradiant mb-2" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}>
                {hero.title}
              </motion.h2>
              <motion.p className="small mb-3 text-muted" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }}>
                {hero.subtitle}
              </motion.p>
              <motion.div className="d-flex flex-wrap gap-3" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}>
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button variant="gradient" size="lg">
                    <i className="ri-flashlight-fill me-2"></i>Get Started
                  </Button>
                </motion.div>
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button variant="outline-primary" size="lg">
                    <i className="ri-play-circle-line me-2"></i>Watch Demo
                  </Button>
                </motion.div>
              </motion.div>
              <motion.div className="mt-3" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6 }}>
                <div className="d-flex align-items-center gap-4">
                  <div className="ratings">
                    {renderStars(hero.rating)}
                    <span className="ms-2 text-primary">{hero.rating}/5</span>
                  </div>
                  <div className="separator"></div>
                  <div className="clients">
                    <span className="text-success fw-bold">{hero.clients}</span>
                    <span className="text-muted ms-1">Happy Clients</span>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </Col>
          <Col lg={6}>
            <motion.div className="hero-image position-relative" variants={imageVariants} initial="hidden" animate="visible" whileHover={{ scale: 1.02, transition: { duration: 0.3 } }}>
              <Card>
                <Card.Img src={getImage(hero.image)} alt="Creative Solutions" />
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>

      <div className="position-absolute bottom-0 start-0 w-100">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#298f9c" fillOpacity="0.2" d="M0,224L60,213.3C120,203,240,181,360,181.3C480,181,600,203,720,224C840,245,960,267,1080,250.7C1200,235,1320,181,1380,154.7L1440,128L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z">
          </path>
          <path fill="#298f9c" fillOpacity="0.4" d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,250.7C960,267,1056,245,1152,224C1248,203,1344,181,1392,170.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
          </path>
        </svg>
      </div>
    </section>
  )
}

export default Herosection;
